import ContentItems from "../ContentItems.component";
import {
  useReadDraftFieldFromCache,
  useReadFieldFromCache,
  useTemplateStoreFromContext,
} from "../Context/hooks";
import { ParentContext } from "../Field/FieldContext";
import { ContentItem, ContentItemDecorator } from "../types";
import { useShallow } from "zustand/react/shallow";

const ConditionalDescriptionWrapper: ContentItemDecorator = ({
  displayName,
  contentItemProps,
  children,
}) => {
  const { ownerType, draftData, publishedData, editMode } =
    useTemplateStoreFromContext()(
      useShallow(state => ({
        ownerType: state.ownerType,
        draftData: state.draftData,
        publishedData: state.publishedData,
        editMode: state.editMode,
      }))
    );

  const readFieldFromCache = useReadFieldFromCache();
  const readDraftFieldFromCache = useReadDraftFieldFromCache();

  if (
    contentItemProps.type !== "section" &&
    contentItemProps.metadata.conditionalDescriptionKey
  ) {
    // TODO: This is wrong doesn't consider manager state. not sure what this is doing
    const conditionalDescriptionKeyField = editMode
      ? draftData?.[ownerType]?.[
          contentItemProps.metadata.conditionalDescriptionKey
        ] ||
        readDraftFieldFromCache(
          contentItemProps.metadata.conditionalDescriptionKey
        )?.field ||
        publishedData?.[ownerType]?.[
          contentItemProps.metadata.conditionalDescriptionKey
        ] ||
        readFieldFromCache(contentItemProps.metadata.conditionalDescriptionKey)
          ?.field
      : publishedData?.[ownerType]?.[
          contentItemProps.metadata.conditionalDescriptionKey
        ] ||
        readFieldFromCache(contentItemProps.metadata.conditionalDescriptionKey)
          ?.field;

    // Removing logic for hiding conditional description text until we implement logic to disable it (PB-1589)

    // if (
    //   (typeof conditionalDescriptionKeyField?.value === "string" &&
    //     !["Yes", "Other"].includes(conditionalDescriptionKeyField?.value)) ||
    //   (typeof conditionalDescriptionKeyField?.value === "boolean" &&
    //     !conditionalDescriptionKeyField?.value) ||
    //   conditionalDescriptionKeyField?.value === undefined ||
    //   conditionalDescriptionKeyField?.notApplicable === true
    // ) {
    //   return null;
    // }
  }

  return <div style={{ marginBottom: "20px" }}>{children}</div>;
};

export default function ConditionalDescriptionSection({
  content,
}: {
  content: ContentItem[];
}) {
  return (
    <ParentContext.Provider value="conditional_description">
      <div>
        <ContentItems
          content={content}
          Component={ConditionalDescriptionWrapper}
        />
      </div>
    </ParentContext.Provider>
  );
}
